import { Col } from "react-bootstrap";
import Insurance from "../../../../components/shipmentDeceleration/Insurance";
import DekapostInsurance from "./DekapostInsurance";

function ShipmentInfo() {
  return (
    <section>
      <hr />
      <div className="d-flex flex-wrap justify-content-around row-gap-2">
        <Col xs={12} lg={6} xxl={5}>
          <p className="h5 text-end">محدودیت های وزنی پستی بشرح زیر می باشد:</p>
          <ul className="mb-0">
            <li>حداکثر وزن برای پست پیشتاز و پست خارجی 30 کیلوگرم</li>
            <li>حداکثر وزن بسته پستی در شرکت های خصوصی 100 کیلوگرم</li>
            <li>حداکثر وزن بسته پستی برای پیک درون شهری 20 کیلوگرم</li>
            <li>
              عدم ارسال بار بیشتر از 100 سانتی متر در یکی از ابعاد در سرویس پست
            </li>
            <li>
              عدم ارسال بار بیشتر از 250 سانتی متر در یکی از ابعاد در سرویس
              خصوصی
            </li>
          </ul>
        </Col>

        <Col xs={12} lg={6} xxl={5}>
          <p className="h5 text-end">
            بیمه مرسولات شما توسط شرکت آواکس بصورت زیر میباشد:
          </p>
          <ul className="mb-0">
            <li>انتخاب بیمه الزامی است.</li>
            <li>حداقل ارزش کالا ده میلیون ريال در نظر گرفته می شود.</li>
            <li>
              <Insurance />
            </li>
            <DekapostInsurance />
          </ul>
        </Col>
      </div>

      <hr />
    </section>
  );
}

export default ShipmentInfo;
